<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" style="display: none">
  <symbol id="wave">
    <path d="M420,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C514,6.5,518,4.7,528.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H420z"></path>
    <path d="M420,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C326,6.5,322,4.7,311.5,2.7C304.3,1.4,293.6-0.1,280,0c0,0,0,0,0,0v20H420z"></path>
    <path d="M140,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C234,6.5,238,4.7,248.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H140z"></path>
    <path d="M140,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C46,6.5,42,4.7,31.5,2.7C24.3,1.4,13.6-0.1,0,0c0,0,0,0,0,0l0,20H140z"></path>
  </symbol>
</svg>
<ng-container breakpoint #ref="value">
  <div
    class="sidenav"
    id="offcanvasWithBothOptions"
    [ngClass]="{ 'sidenav-width': sideNavService.isClose, 'offcanvas offcanvas-start overlay offcanvas-width': (ref.isSmallerThan('sm') | async) }"
  >
    <div class="sidenav-top d-flex">
      <div class="sidenav-header" *ngIf="header">
        <span class="text" id="header" [ngClass]="{ 'text-hide': !ref.isMobile && sideNavService.isClose }">{{ header }}</span>
        <button
          [id]="'hamburgerBtn'"
          (click)="!ref.isMobile && openCloseSideNav()"
          class="btn btn-ghost btn-neutral btn-lg ti-menu"
          [attr.data-bs-dismiss]="ref.isMobile ? 'offcanvas' : null"
          aria-label="Close"
        >
        </button>
      </div>
    </div>
    <div class="sidenav-body">
      <div class="sidenav-middle">
        <div class="sidenav-list" [ngClass]="{ 'margin-left': sideNavService.isClose }">
          <ul
            class="li-container sidenav-ul d-flex flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start"
            [ngClass]="{ 'li-container-width': sideNavService.isClose, 'offcanvas-li-container-width': ref.isMobile }"
            ><li (click)="checkRoute(item)" class="sidenav-li" *ngFor="let item of items; let i = index" [ngClass]="{ 'mb-4': item.space }">
              <a
                [routerLink]="item.link"
                routerLinkActive="active"
                class="d-flex menu-item"
                [ngClass]="{ 'justify-content-center': !ref.isMobile && sideNavService.isClose }"
                [id]="'sidenavItem' + i"
              >
                <span class="menu-item-icon ti-lg" [ngClass]="item.icon" [title]="commonService.translateLabel(item.label)"></span>
                <span class="menu-item-label" *ngIf="ref.isMobile || (!ref.isMobile && !sideNavService.isClose)">{{ commonService.translateLabel(item.label) }}</span>
                <div class="line" [ngClass]="{ 'margin-class-end': true }"></div>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div *ngIf="quota" class="sidenav-quota-container">
        <div *ngIf="!sideNavService.isClose" class="quota-text">
          <div class="quota-text-label">{{ commonService.translateLabel(quota.label) }}</div>
          <div class="quota-text-value">{{ quota.usage }} / {{ quota.total }}</div>
        </div>
        <div class="quota-circle">
          <div class="quota-wave-container">
            <div class="quota-wave" [style.top.%]="90 - (quota.percentage > 100 ? 100 : quota.percentage) * 0.8"></div>
          </div>
          <div class="quota-circle-percentage">%{{ quota.percentage | number : '1.0-0' }}</div>
        </div>
      </div>
      <div *ngIf="false && !sideNavService.isClose" class="sidenav-whitelabel-container">
        <img class="sidenav-whitelabel-logo" src="/assets/images/logos/bilgem-logo.svg" alt="Logo" />
      </div>
      <div class="sidenav-trademark-container">
        <div class="sidenav-trademark-logo-container">
          <img [ngClass]="{ 'sidenav-trademark-logo-closed': sideNavService.isClose }" src="/assets/images/logos/bilgem-logo.svg" alt="Bilgem Logo" />
        </div>
        <div *ngIf="!sideNavService.isClose" class="sidenav-trademark-text"> © {{ currentYear }}<br />TÜBİTAK BİLGEM </div>
      </div>
    </div>
  </div>
</ng-container>
